import type { App } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// 전역 플래그를 사용하여 router가 이미 설치되었는지 확인
declare global {
  interface Window {
    _vueRouterInstalled?: boolean;
  }
}

export default function (app: App) {
  // 이미 Vue Router가 설치되었는지 확인
  if (window._vueRouterInstalled) {
    console.log('Vue Router already installed, skipping');
    return;
  }
  
  // Vue Router 설치
  try {
    app.use(router);
    window._vueRouterInstalled = true;
  } catch (error) {
    console.error('Error installing Vue Router:', error);
  }
}

export { router };
